import {
  DocumentOrganizationKeys,
  FilterDocument,
  FilterOptionKeys,
  Tag,
} from '@griply/types';

import { getTagDefaultFilterDocument } from './get-tag-default-filter-document';

export const getTagFilterDocument = (tag?: Tag): FilterDocument => {
  const base = getTagDefaultFilterDocument(tag);

  return {
    ...base,
    ...(tag?.filterDocument ?? {}),
    [DocumentOrganizationKeys.Filters]: {
      ...base.filters,
      ...(tag?.filterDocument?.filters ?? {}),
      // The tag scope is the identity of this view — never let a persisted
      // `filters.tag: null` (or any override) widen the result set beyond
      // this tag. Always re-apply the default tag include from `base`.
      [FilterOptionKeys.Tag]: base.filters?.[FilterOptionKeys.Tag],
    },
  };
};
